export const NAV_ITEMS = [
  { label: 'Beranda', path: '/' },
  { label: 'Tentang Yayasan', path: '/about' },
  { label: 'Unit Pendidikan', type: 'dropdown' },
  { label: 'Beasiswa', path: '/scholarships' },
  { label: 'Blog', path: '/news' },
  { label: 'SPMB Online', path: '/spmb' },
  { label: 'FAQ', path: '/faq' },
  { label: 'Karir', path: '/career' },
];
